import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@atlas/ui';

export const RedirectButton = ({ label, value }) => {
  const handleRedirect = useCallback(() => {
    window.location.href = value;
  }, [value]);

  return <Button className="redirect-button" label={label} onClick={handleRedirect} size="big" />;
};

RedirectButton.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
